export const formatWhatsappUsername = additionalAttributes => {
  const attributes = additionalAttributes || {};
  const candidates = [
    attributes.social_whatsapp_user_name,
    attributes.socialWhatsappUserName,
    attributes.social_profiles?.whatsapp,
    attributes.socialProfiles?.whatsapp,
  ];

  const username = candidates
    .filter(value => typeof value === 'string')
    .map(value => value.trim().replace(/^@+/, '').trim())
    .find(Boolean);

  return username ? `@${username}` : '';
};
